import IMAGES from '@/public/assets/img';
import { WEB_URL } from '@/config/endpoints';

export default {
    ShimmerSec:false,
    WhatsAppText:{
        labelText:"Conéctate a Whats App",
        desktopNo:'+52 5560820990',
        desktopMessage:"Hola, bienvenido a la cuenta oficial de WhatsApp de Credlix.",
        mobileNo:'+52 5560820990',
        mobileMessage:"Hola, bienvenido a la cuenta oficial de WhatsApp de Credlix.",
        contactName:'Oficial de Credlix'
    },
    MenuLinks:[
        {name:'Exportadores', href:WEB_URL+'/es-mx/export-factoring', 
            subMenu:[
                { name: 'Factoraje', href: WEB_URL+'/es-mx/export-factoring' ,src: IMAGES.SHARED.sbDiscount},
                
                
            ]
        },
        {name:'Compradores Global', href:WEB_URL+'/es-mx/global-buyer',subMenu:null },
        {name:'Herramientas', href:null, subMenu:[
            { name: 'Calculadora de intereses', href: '/interest-calculator', text: 'Calcule el mejor precio para el financiamiento de exportaciones', src: IMAGES.SHARED.iCalc },
            ]
        },
        {name: 'Sobre nosotros', href: WEB_URL+'/es-mx/about-us',subMenu:null},
        {name:'Recursos',href: WEB_URL+'/es-mx/blogs', subMenu:[
            { name: 'Blogs', href: WEB_URL+'/es-mx/blogs', text:'Pensamientos, consejos y charla tecnológica'},
            { name: 'News', href: WEB_URL+'/es-mx/news', text: 'Lo más reciente, todo en un solo lugar' }]},
        { name: 'Aliados', href: WEB_URL+'/es-mx/partner-program' }
    ],
    RightMenuLinks:[
        {name:'Acceso', href:'https://app.credlix.com/#/auth/login'},
        {name:'Inscribirse', href:'https://app.credlix.com/#/auth/login'},
    ],
    Login: {name:'Acceso', href:'https://app.credlix.com/#/auth/login'},
    SignUp:{name:'Inscribirse', href:'https://app.credlix.com/nuphi/#/signup/exporter/verify'},

    // Content For footer starts
    FooterIndiaForm:false,
    FooterMexicoForm:true,
    FooterUSForm:false,
    FooterLeftText:{
        heading:'Optimiza tu flujo de efectivo con Credlix y convierte tus cuentas por cobrar en efectivo',
        para:'Registrate en nuestra plataforma y compártenos algunos detalles de tu empresa para brindarte un servicio simple, personalizado y a la medida de tus necesidades para que liberes el potencial de tus exportaciones.',
        list:[
            'Una empresa certificada ISO',
            'Aprobación instantánea, desembolso rápido',
            'Accede a capital libre de colateral con documentación mínima',
            '100% de visibilidad en nuestro portal',
            'Miembro De',
        ]
    },
    Scanner:false,
    MexicoFormFieldsLabels:{
        commonError:'Este campo es obligatorio.',
        emailNotValid:'El correo no es válido.',
        restrictEmail:"Por favor proporcione el correo electrónico oficial asociado con la empresa.",
        phoneInvalid:'Numero de telefono invalido.',
        heading1:'Obtenga acceso inmediato',
        heading2:'CAPITAL DE TRABAJO',
        emailLabel:'Correo electrónico*',
        emailPlaceholder:'Introduce tu correo electrónico',
        phoneLabel:'Número de teléfono*',
        phonePlaceholder:'Ingrese su número telefónico',
        companyLabel:'Nombre de empresa*',
        companyPlaceholder:'Introduzca el nombre de su empresa',
        financeLabel:'Financiamiento requerido* ',
        mIFinanceLabel:'Financiamiento requerido (opcional)',
        financePlaceholder:'Ingrese el monto de su finan..',
        submit:'Obtener financiación',
        successMsg:'Envío exitoso: Gracias por su interés. ',
        countrycodeLabel: 'Código de país',
        countrycodePlaceholder: 'Seleccionar',
        companytypeLabel: 'Tipo de empresa*',
        companytypePlaceholder: 'Ingrese su tipo de empresa...',
        countrycodeDataMexicoConnect:[
            {id:1, code:'Mexico (+52)', Showname:'México (+52)'},
            {id:2, code:'Canada (+1)', Showname:'Canadá (+1)'},
            {id:3, code:'USA (+1)', Showname:'Estados Unidos (+1)'},
        ],
        countrycodeData:'México (+52)',
        // mITradeHeading:'Simplifica tus importaciones desde India — Conéctate ahora',
        mISubBtn:'Conéctate ahora'
    },
    miSupplier:{
        otpVerified:'OTP verificado!',
        connectHeading:'Conectar con compradores mexicanos - Aplicar ahora',
        fetchDetails:'Obtener detalles',
        companyName:'Nombre de empresa',
        name:'Introduce tu nombre',
        emailId:'Ingrese su ID de correo electrónico',
        phone:'Ingrese su número de teléfono',
        verify:'Verificar',
        verifying:'Verificando...',
        verified:'Verificado',
        invalidPhone:'Número de teléfono inválido',
        captchaIssue:'Problema de captcha o red',
        fetching:'Atractivo...',
        getOtp:"¿No obtuve OTP?",
        resend:'Reenviar en',
        enterOtp:'Ingrese la OTP',
        correctOtp:'Por favor ingrese el OTP correcto',
        incorrectOtp:'OTP incorrecta',
        term1:'Estoy de acuerdo con el',
        terms:'Términos',
        privacy:'política de privacidad',
        checkFinance:'Verificar la elegibilidad de financiamiento',
        successMsg:'Envío exitoso: Gracias por su interés.'
    },

    fixedCTA:'Obtener financiación',
    Address:{
        country:'Mexico',
        addressName:{
            name:'Dirección',
            content:'Puebla 403 A, Roma Nte., Cuauhtémoc, 06700 Ciudad de México, CDMX, Mexico'
        },
        email:'Correo electrónico',
        emailId:'genette.herrera@moglix.com, natalia.delapaz@moglix.com, javier.santos@credlix.com',
        contact:'Contacto',
        phone:'+52 55 4544 9526, +52 55 3680 9229, +52 55 2298 2949'
    },
    copyright:'Derechos de autor © ',
    ExitForm:true,
    BlueBgHeading:'Optimiza tu flujo de efectivo con Credlix y convierte tus cuentas por cobrar en efectivo',
    SuppList:[
        {image:IMAGES.SHARED.ftIcon1,boldText:'Una empresa,',text:'certificada ISO'},
        {image:IMAGES.SHARED.ftIcon2,boldText:'Documentación mínima,',text:'sin garantías concretas'},
        {image:IMAGES.SHARED.ftIcon3,boldText:'Aprobación instantánea,',text:'desembolso rápido'},
        {image:IMAGES.SHARED.ftIcon4,boldText:'100% visibilidad,',text:'paneles digitales'},
    ],
    ThankyouResponse:{
        ThankYou_page_heading:'Gracias por contactar con nosotros.',
        ThankYou_page_para:'Nos comunicaremos con usted en breve.',
    },
    SeoContent:{
        title:'Gracias por contactar',
        url:WEB_URL+'/es-mx/thankyou-response',
        name:'description',
        description:'Gracias por contactar.'
    },
    ResLinks:[
        {link:'/blogs',name:'Blogs',target:'_self'},
        {link:'/news',name:'Noticias',target:'_self'},
    ],
    pageNotFound:{
        title:'Página no encontrada',
        description:'Lo sentimos, no se pudo encontrar la página que estás buscando.',

    },
    pageGone: {
        title: 'Contenido no disponible',
        description: 'Esta página ya no está disponible ya que el contenido ha sido eliminado permanentemente.',
        metaTitle: '410 - Contenido no disponible | Credlix',
        metaDescription: 'Esta página ya no está disponible ya que el contenido ha sido eliminado permanentemente.',
        returnTextPrefix: 'También puedes regresar a nuestra ',
        homePageText: 'página de inicio',
        homePageUrl: '/es-mx',
        returnTextMiddle: ', o ',
        contactUsText: 'contactarnos',
        contactUsUrl: '/contact-us',
        returnTextSuffix: '.'
    }

    // Content For footer end


}